import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
  Redirect,
  useLocation,
} from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { GuardRoute } from '../_shared/GuardRoute';

import { MyAccount } from './my-account/MyAccount';
import { PersonalInformation } from './personal-information/PersonalInformation';
import { CommunicationPreferences } from './communication-preferences/CommunicationPreferences';
import { ChangePassword } from './change-password/ChangePassword';
import { MultiFactorAuthentication } from './multi-factor-authentication/MultiFactorAuthentication';
import { EpicRedirect } from './providers/epic/EpicRedirect';
import { SteamRedirect } from './providers/steam/SteamRedirect';
import { Game } from './my-games/Game';
import { Preregistration } from '../preregistration/Preregistration';

export function Account(): JSX.Element {
  const match = useRouteMatch();

  const location = useLocation();

  return (
    <>
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.pathname}>
          <Route path={`${match.path}/my-account`} exact component={MyAccount} />

          <Route path={`${match.path}/my-account/games/:gameId`} exact component={Game} />
          <GuardRoute path={`${match.path}/my-account/games/:gameId/preregistration`} authRoute>
            <Preregistration />
          </GuardRoute>

          <Route path={`${match.path}/personal-information`} exact component={PersonalInformation} />
          <Route
            path={`${match.path}/communication-preferences`}
            exact
            component={CommunicationPreferences}
          />
          <Route path={`${match.path}/change-password`} exact component={ChangePassword} />
          <Route path={`${match.path}/mfa`} exact component={MultiFactorAuthentication} />
          <Route path={`${match.path}/epic/redirect`} exact component={EpicRedirect} />
          <Route path={`${match.path}/steam/redirect`} exact component={SteamRedirect} />

          <Redirect to={`${match.path}/my-account`} />
        </Switch>
      </AnimatePresence>
    </>
  );
}
